import { createAction } from 'redux-actions';

export const offerHotelsAction = createAction<boolean>('OFFER_HOTELS');
